import type {
    AgentNegativeCarryoverReport,
    AgentNegativeCarryoverReportPage,
    Timestamp,
    WeeklySummaryExport,
    WeeklySummaryExportPage,
} from '@igp/shared/contract/pam';
import type {Path, SortKeys} from '@igp/shared/utils';

export const generalItemId = 'AgentNegativeCarryoverReportGeneralItem';

export type AgentNegativeCarryoverReportExtended = AgentNegativeCarryoverReport & {
    is_general?: boolean;
    last_updated?: Timestamp;
};

export type NegativeCarryoverReportQueryFields = Path<AgentNegativeCarryoverReportPage>;

export type NegativeCarryoverReportDownloadFields = Path<AgentNegativeCarryoverReport>;

export type NegativeCarryoverReportViewModel = {
    id: string;
    agentUid: string;
    debtAfterPayment?: number;
    debtBeforePayment?: number;
    debtTransaction?: number;
    totalNetShare?: number;
    weekStartDateTs?: Timestamp;
    weeklyActuallyPaid?: number;
    lastUpdated?: Timestamp;
    isGeneral?: boolean;
};

export type NegativeCarryoverReportViewModelKeys = keyof Omit<NegativeCarryoverReportViewModel, 'lastUpdated' | 'isGeneral'>;
export class NegativeCarryoverReportDownloadModel implements Record<NegativeCarryoverReportViewModelKeys, string> {
    id: string;
    agentUid: string;
    debtAfterPayment: string;
    debtBeforePayment: string;
    debtTransaction: string;
    totalNetShare: string;
    weekStartDateTs: string;
    weeklyActuallyPaid: string;
}

export type NegativeCarryoverReportSortKeys = SortKeys<AgentNegativeCarryoverReport>;

export type NegativeCarryoverWeeklySummaryQueryFields = Path<WeeklySummaryExportPage>;

export type NegativeCarryoverWeeklySummaryViewModel = {
    aal?: string;
    agent_uid: string;
    comments?: string;
    direction?: string;
    reason_codes?: string;
    reference?: string;
    weekly_actually_paid: number;
    turnover_rate: number;
};

export type NegativeCarryoverWeeklySummaryViewModelKeys = Path<NegativeCarryoverWeeklySummaryViewModel>;

export class NegativeCarryoverWeeklySummaryDownloadModel implements Record<NegativeCarryoverWeeklySummaryViewModelKeys, string> {
    aal: string;
    agent_uid: string;
    comments: string;
    direction: string;
    reason_codes: string;
    reference: string;
    weekly_actually_paid: string;
    turnover_rate: string;
}

export type NegativeCarryoverWeeklySummaryDownloadFields = Path<WeeklySummaryExport>;

export const NegativeCarryoverReportServiceTypes = {
    Service: Symbol('NegativeCarryoverReportService'),
    DownloadClientStrategy: Symbol('NegativeCarryoverReportDownloadClientStrategy'),
    DownloadServerStrategy: Symbol('NegativeCarryoverReportDownloadServerStrategy'),
    WeeklySummaryService: Symbol('NegativeCarryoverWeeklySummaryService'),
    WeeklySummaryDownloadClientStrategy: Symbol('NegativeCarryoverWeeklySummaryDownloadStrategy'),
    WeeklySummaryDownloadServerStrategy: Symbol('NegativeCarryoverWeeklySummaryDownloadServerStrategy'),
};
